import React from 'react';
import {
  ModalFooter as ChakraModalFooter,
  Link,
  Button,
} from '@chakra-ui/react';

const ModalFooter = (props: {
  ctaButton: { text: string; url: string };
  dismissButton: { text: string; onClick: () => void };
}) => (
  <ChakraModalFooter justifyContent="center" css={{ gap: '20px' }}>
    <Link href={props.ctaButton.url} isExternal _focus={{ boxShadow: 'none' }}>
      <Button
        paddingX={6}
        bg="#B70C7F"
        color="white"
        borderRadius="full"
        fontSize="sm"
        _hover={{ bg: '#960A68' }}
        _active={{ bg: '#960A68' }}
        _focus={{ boxShadow: 'none' }}
      >
        {props.ctaButton.text}
      </Button>
    </Link>

    <Button
      paddingX={6}
      fontSize="sm"
      colorScheme="white"
      variant="outline"
      borderRadius="full"
      onClick={props.dismissButton.onClick}
      _focus={{ boxShadow: 'none' }}
    >
      {props.dismissButton.text}
    </Button>
  </ChakraModalFooter>
);

export default ModalFooter;
